<template>
  <div style="display:none;border: 1px solid red">
    <v-btn
      color="light-green"
      light-green
      dark
      fab
      fixed
      bottom
      right
      style="right: 80px"
    >
      <v-icon>done_all</v-icon>
    </v-btn>

    <v-btn color="grey" dark fab fixed bottom right @click="clearSelectedItems">
      <v-icon>refresh</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("matching");

export default {
  components: {},
  methods: {
    ...mapMutations(["clearSelectedItems"]),
    // ...mapActions(["saveCorrection"]),
    // ...mapMutations(["setAllItemsCorrectness", "setUnmarkedItemsCorrectness"]),
    // toggleClassificationSelectionDialogVisibility() {
    //   this.showingClassificationSelectionDialog = !this
    //     .showingClassificationSelectionDialog;
    // },
    // toggleQuantitySelectionDialogVisibility() {
    //   this.showingQuantitySelectionDialog = !this
    //     .showingQuantitySelectionDialog;
    // },
    clearSelectedItems() {
      this.clearSelectedItems();
    }
  },
};
</script>
